import { GetLocationSuggestionsPayload } from '@griply/services';
import { LocationSuggestion } from '@griply/types';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useRef } from 'react';
import { getLocationSuggestions } from 'shared/services/backend-api';

export const queryKey = 'location-suggestions';

export const useLocationSuggestionsQuery = () => {
  // refetch() takes no args, so the latest payload travels via a ref
  const payloadRef = useRef<GetLocationSuggestionsPayload | null>(null);

  const { data, isFetching, refetch } = useQuery<LocationSuggestion[]>({
    queryKey: [queryKey],
    queryFn: () =>
      payloadRef.current
        ? // already Sentry-reported by the wrapper; an empty list just hides the dropdown
          getLocationSuggestions(payloadRef.current).catch(() => [])
        : [],
    // seeded + disabled: an unseeded pending query would suspend the dialog under the global suspense default
    enabled: false,
    initialData: [],
    retry: false,
  });

  const fetchSuggestions = useCallback(
    (payload: GetLocationSuggestionsPayload) => {
      payloadRef.current = payload;
      refetch();
    },
    [refetch],
  );

  return { suggestions: data, isFetching, fetchSuggestions };
};
